import { render, staticRenderFns } from "./ChoiceModal.vue?vue&type=template&id=1dfa1f2b"
import script from "./ChoiceModal.vue?vue&type=script&lang=js"
export * from "./ChoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports